import { isEmpty } from 'lodash';

import {
    RECEIVE_PAYMENT_REQUESTS,
    REQUEST_PAYMENT_REQUESTS,
    FAILURE_PAYMENT_REQUESTS
} from './constants';

import { CALL_API } from '../../../../middlewares/api';

export function fetchPaymentRequestsIfNeeded(forceFetch = false) {
    return {
        [CALL_API]: {
            endpoint: '/payment',
            types: [REQUEST_PAYMENT_REQUESTS, RECEIVE_PAYMENT_REQUESTS, FAILURE_PAYMENT_REQUESTS],
            shouldCallAPI: state => forceFetch || shouldFetchPaymentRequests(state),
            authenticated: true
        }
    };
}

const shouldFetchPaymentRequests = state => {
    const data = state.account.paymentrequest.requests;
    const fetching = state.account.paymentrequest.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(data)) {
        return true;
    } else {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/actions.js